<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit }"
    slim
  >
    <form
      role="form"
      class="addresses form-horizontal"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <fieldset>
        <!-- Name -->
        <Field
          :label="$t('ADDRESS_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_name"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.name"
                    type="text"
                    
                    name="addr_name"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <!-- Country Dropdown -->
        <Field
          :label="$t('ADDRESS_COUNTRY')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_COUNTRY_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="country"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <CountrySelector
                    id="country"
                    v-model="countryValue"
                    name="country"
                    :placeholder="$t('ADDRESS_COUNTRY_PLACEHOLDER')"
                  />
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>



        <!-- Business Name -->
        <Field
          :label="$t('ADDRESS_COMPANY')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_COMPANY_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_business"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.customerName"
                    type="text"
                    name="addr_business"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>


        <!-- Street Address -->
        <Field
          :label="$t('ADDRESS_STREET')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_STREET_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_street"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.streetAddress"
                    type="text"
                    
                    name="addr_street"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>


        <!-- City -->
        <Field
          :label="$t('ADDRESS_CITY')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_CITY_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_city"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.city"
                    type="text"
                    
                    name="addr_city"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>


        <!-- State/Region -->
        <Field
          :label="$t('ADDRESS_STATE')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_STATE_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_state"
              rules=""
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.region"
                    type="text"
                    name="addr_state"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
              </div>
            </ValidationProvider>
          </template>
        </Field>


        <!-- ZIP -->
        <Field
          :label="$t('ADDRESS_ZIP')"
          :has-tooltip="true"
          :tooltip-text="$t('ADDRESS_ZIP_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="addr_zip"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="innerValue.postalCode"
                    type="text"
                    
                    name="addr_zip"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

     

        <!-- Action Buttons -->
        <div class="form-group">
          <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">            
            <PrimaryButton
              size="sm"
              :show-loader-on-form="showLoader"
            >
              <span v-t="isNewAddress ? 'CREATE' : 'UPDATE'" />
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              class="btn btn-sm btn-danger m-l-15"
              @click="cancel"
            />
          </div>
        </div>
      </fieldset>
    </form>
  </ValidationObserver>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import PrimaryButton from '@/core/components/PrimaryButton';
import CountrySelector from '@/core/components/CountrySelector/CountrySelector.vue';

export default {
  name: 'AddressForm',
  components: { Field, PrimaryButton, CountrySelector },
  props: {
    showLoader: {
      type: Boolean,
      default: () => true
    }, 
    currentAddress: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isNewAddress: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({

    /** @type {ringba.data.AddressRecord} */
    innerValue: {}
  }),
  computed: {
    address() { return _.cloneDeep(this.currentAddress); },
    countryValue: {
      get() {
        const label = this.innerValue.countryName;
        const value = this.innerValue.countryCode;


        // Instead of returning an empty object, return null
        if(!label || !value) {
          return null;
        }

        return {
          label,
          value
        };
      },
      set({label, value}) {
        this.innerValue = {
          ...this.innerValue,
          countryName: label,
          countryCode: value
        };
      }
    },
    postParameters() {
      return this.toPostParams(this.innerValue);
    }
  },
  beforeMount() {
    
    this.innerValue = {
      ...this.currentAddress
    };
  },
  methods:{
    onSubmit() {
      this.$emit('submit', this.postParameters);
    },
    cancel() {
      this.$emit('cancel', this.address);
    },

    /** @type {(addr: ringba.data.AddressRecord) => ringba.data.AddressPostParams} */
    toPostParams(addr) {

      const {
        accountId,
        city,
        countryCode,
        countryName,
        customerName,
        enabled,
        id,
        isDefault,
        name,
        postalCode,
        region,
        streetAddress,
        version,
      } = addr;
      
      return {
        accountId,
        city,
        countryCode,
        countryName,
        customerName,
        enabled,
        id,
        isDefault,
        name,
        postalCode,
        region,
        status,
        streetAddress,
        version,
      };
  
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>